export default __webpack_public_path__ + "static/media/Strifescar Tasset.f3d59e5b.jpg";